"use strict";Object.defineProperty(exports, "__esModule", {value: true});

var _AVNURAH2cjs = require('../__chunks/AVNURAH2.cjs');


var _LBUQETMNcjs = require('../__chunks/LBUQETMN.cjs');
require('../__chunks/6P52IAFY.cjs');
require('../__chunks/PFM4PJSG.cjs');
require('../__chunks/SARAALGA.cjs');
require('../__chunks/UCZW3OGH.cjs');


var _FH6HQ5JNcjs = require('../__chunks/FH6HQ5JN.cjs');
require('../__chunks/XWMMMXUK.cjs');




var _PTOCUU2Dcjs = require('../__chunks/PTOCUU2D.cjs');
require('../__chunks/3BSDKDKD.cjs');
require('../__chunks/XMDZRF6Y.cjs');

// src/select/select-row.tsx
var _dom = require('@ariakit/core/utils/dom');
var _misc = require('@ariakit/core/utils/misc');
var TagName = "div";
var useSelectRow = _PTOCUU2Dcjs.createHook.call(void 0, 
  function useSelectRow2({ store, ...props }) {
    const context = _AVNURAH2cjs.useSelectContext.call(void 0, );
    store = store || context;
    _misc.invariant.call(void 0, 
      store,
      process.env.NODE_ENV !== "production" && "SelectRow must be wrapped in a SelectList or SelectPopover component"
    );
    const listElement = _FH6HQ5JNcjs.useStoreState.call(void 0, store, "listElement");
    const popupRole = _dom.getPopupRole.call(void 0, listElement);
    const role = popupRole === "grid" ? "row" : "presentation";
    props = { role, ...props };
    props = _LBUQETMNcjs.useCompositeRow.call(void 0, { store, ...props });
    return props;
  }
);
var SelectRow = _PTOCUU2Dcjs.forwardRef.call(void 0, function SelectRow2(props) {
  const htmlProps = useSelectRow(props);
  return _PTOCUU2Dcjs.createElement.call(void 0, TagName, htmlProps);
});



exports.SelectRow = SelectRow; exports.useSelectRow = useSelectRow;
